import React from "react";

/**
 * Opsora — Error Boundary.
 *
 * Catches render-time errors in any descendant component so a thrown
 * exception in one screen does not unmount the entire application.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Surface to the browser console so it is captured in any log relay.
    // eslint-disable-next-line no-console
    console.error("Opsora ErrorBoundary caught:", error, info);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="glass-card"
          style={{ padding: "2rem", textAlign: "center", margin: "2rem auto", maxWidth: 520 }}
          data-testid="error-boundary"
        >
          <div
            style={{
              fontFamily: "var(--font-display)",
              fontSize: 22,
              color: "var(--slate-900)",
              marginBottom: 8,
            }}
          >
            Something went wrong loading this section
          </div>
          <p style={{ color: "var(--slate-500)", fontSize: 13, marginBottom: 16 }}>
            {this.state.error?.message || "Please try again. If this keeps happening, refresh the page."}
          </p>
          <button onClick={this.reset} className="btn-copper" data-testid="error-boundary-retry">
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
